import {inject, Injectable} from '@angular/core';
import {APIRequest, APIRequestResources, PaginationResponse} from "../../../../../core";
import {BehaviorSubject} from "rxjs/internal/BehaviorSubject";
import {toSignal} from "@angular/core/rxjs-interop";
import {HttpClient} from "@angular/common/http";
import {ProductSampleFindDTO, ProductSampleGetDTO, SampleValidationDTO} from "../interfaces/product-sample.entity";
import {catchError, from, map, Observable, Subject, switchMap, tap} from "rxjs";
import {ProductDevelopmentPdfService} from "../../../../feature/New-Modules/product-devolopment/services/product-development-pdf.service";
import {
    SampleDesignDto
} from "../../../../feature/New-Modules/product-devolopment/interface/sample-materilas.interface";
import {handleError} from "../../../../../core/util/util";

@Injectable({
    providedIn: 'root'
})
export class ProductSampleNewService extends APIRequest {

    private pdfService = inject(ProductDevelopmentPdfService);

    private readonly $all = new BehaviorSubject<ProductSampleFindDTO[]>([]);
    all = toSignal(this.$all, {initialValue: []})

    private readonly $quickAll = new BehaviorSubject<ProductSampleFindDTO[]>([]);
    quickAll = toSignal(this.$quickAll, {initialValue: []})

    private readonly $active = new BehaviorSubject<ProductSampleGetDTO | undefined>(undefined);
    active = toSignal(this.$active, {initialValue: undefined})

    private sampleCreated = new Subject<void>();


    constructor(protected override http: HttpClient) {
        super(http, APIRequestResources.ProductSampleService)
    }

    find = (searchParams: any, refresh = false) => {
        return this.get<PaginationResponse<ProductSampleFindDTO[]>>({
            endpoint: `find`,
            params: searchParams,
        })
            .pipe(
                tap((res) => this.$all.next(res.data.data)),
            )
    }

    getById = (id: any) => {
        return this.get<ProductSampleGetDTO>({id})
           
    }

    sampleValidator = (id: any) => {
        return this.get<SampleValidationDTO>({endpoint: `validate/${id}`})

    }

    create = (payload: any) => {
        return this.post<any>(payload, {})
    }

    assignMaterials = (payload: any) => {
        return this.post<any>(payload, {
            endpoint: `materials`,
        })
    }

    update = (salesOrderId: number, salesOrderDetail: any) => {
        const options = {suffix: salesOrderId.toString()};
        return this.patch<any>(salesOrderDetail, options);
    }
    
    quickFind = (searchParams: any, refresh = false) => {
        return this.get<ProductSampleFindDTO[]>({
            endpoint: `search`,
            params: searchParams,
        })
            .pipe(
                tap((res) => this.$quickAll.next(res.data)),
            )
    }


    sampleDesignGet = (id: any) => {
        return this.get<SampleDesignDto[]>({
            endpoint: `design/${id}`,
        })

    }

    samplePrint = (id: any, refresh = true): Observable<{ body: Blob }> => {
        return this.get<any>({endpoint: `print-data/${id}`})
            .pipe(
                switchMap(res => from(this.pdfService.productSamplePdf(res.data))),
                map(body => ({body})),
                catchError(handleError)
            );
    }

    deleteMaterial = (id: any) => {
        return this.delete<any>({endpoint: `remove/${id}`}).pipe(
        );
    }

    notifySampleCreated() {
        this.sampleCreated.next();
    }

    onSampleCreated() {
        return this.sampleCreated.asObservable();
    }

    initial  = () => {
        this.$active.next(undefined)
    }
}